import { createSlice } from '@reduxjs/toolkit';
const transaction: any = {};
const filters: any = {};

const complianceManagementSlice = createSlice({
	name: 'complianceManagement',
	initialState: {
		isLoading: false,
		transactions: [],
		transaction,
		filters,
	},
	reducers: {
		setComplianceTransactionIsLoading: (state) => {
			state.isLoading = true;
		},
		resetComplianceTransactionIsLoading: (state) => {
			state.isLoading = false;
		},
		setComplianceTransactions: (state, action) => {
			state.transactions = action.payload;
		},
		resetComplianceTransactions: (state) => {
			state.transactions = [];
		},
		setComplianceTransaction: (state, action) => {
			state.transaction = action.payload;
		},

		resetComplianceTransaction: (state) => {
			state.transaction = {};
		},

		setComplianceTransactionFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetComplianceTransactionFilters: (state) => {
			state.filters = {};
		},
	},
});
export const {
	setComplianceTransaction,
	resetComplianceTransaction,
	setComplianceTransactionIsLoading,
	resetComplianceTransactionIsLoading,
	setComplianceTransactions,
	resetComplianceTransactions,
	setComplianceTransactionFilters,
	resetComplianceTransactionFilters,
} = complianceManagementSlice.actions;
export default complianceManagementSlice.reducer;
